module.exports = ['info', 'error', 'warning', 'success'];
